import { DropdownOption } from '@app/v2/shared/types/dropdown-options.type'
import { USER_ROLES } from '@app/v2/shared/types/user.type'
import { getRoleIcon } from './role-icons'

const BLUE_600_HEX = '#2563EB'

export const MANAGE_TEAM_ASSIGNABLE_ROLES: USER_ROLES[] = [USER_ROLES.ADMIN, USER_ROLES.COLLABORATOR, USER_ROLES.ACCOUNTANT, USER_ROLES.VIEWER]

export type RolesDropdownPermissions = {
  canChange: boolean
  assignableRoles: USER_ROLES[]
}

const formatRoleLabel = (role: USER_ROLES): string => role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()

/**
 * @description Returns the roles dropdown options
 * @param permissions RolesDropdownPermissions
 * @returns DropdownOption[]
 */
export function getRolesDropdownOptions(permissions: RolesDropdownPermissions): DropdownOption[] {
  if (!permissions.canChange) return []

  return permissions.assignableRoles.map((role) => ({
    key: role,
    value: formatRoleLabel(role),
    prefixIcon: getRoleIcon(role).replace(/fill="#[0-9A-Fa-f]{6}"/g, `fill="${BLUE_600_HEX}"`) as `<svg${string}</svg>`
  }))
}
